import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import HorizontalRule from 'components/HorizontalRule';
import MarketplaceStatsModal from './MarketplaceStatsModal';
import './NewJobPosterDashboard.scss';

const HELP_ARTICLES = [
  { label: 'How does the hiring process work?' },
  { label: 'How do I post a job on Go4?' },
  { label: 'Do I need to send ATs a 1099?' },
];

const formatNumber = n => (n == null ? '—' : Number(n).toLocaleString());
const formatRate = r => (r == null ? '—' : `$${Number(r).toFixed(2)}`);

class NewJobPosterDashboard extends Component {
  state = { modalOpen: false };

  openModal = () => this.setState({ modalOpen: true });
  closeModal = () => this.setState({ modalOpen: false });

  render() {
    const { user, marketplaceStats } = this.props;
    const { modalOpen } = this.state;
    const {
      atsOnPlatform,
      hoursPosted,
      jobsPosted,
      atsWithin50Miles,
      avgTransactedRate,
      currentZip,
      loading,
    } = marketplaceStats;

    const displayZip = currentZip || user.addressZip || 'XXXXX';
    const displayState = user.state || 'your area';

    const initials = [user.firstName, user.lastName]
      .filter(Boolean)
      .map(n => n[0].toUpperCase())
      .join('');

    const jpType = user.userPersona || user.type || 'JP Type';

    const platformStats = [
      { label: 'ATs On The Platform', value: formatNumber(atsOnPlatform) },
      { label: 'Hours Posted On The Platform', value: formatNumber(hoursPosted) },
      { label: 'Jobs Posted On The Platform', value: formatNumber(jobsPosted) },
    ];

    return (
      <div className="new-jp-dashboard">
        <div className="njp-header">
          <h1 className="njp-welcome">{user.firstName}, welcome to Go4</h1>
          <div className="njp-org">
            <span className="njp-org-name">{user.companyName || 'Organization Name'}</span>
            <div className="njp-avatar">
              {user.profilePic ? <img src={user.profilePic} alt="profile" /> : initials}
            </div>
          </div>
        </div>

        <HorizontalRule margin="0" />

        <div className="njp-trainers-card">
          <h5 className="njp-card-title">Athletic Trainers In Your Area</h5>
          <HorizontalRule dashed margin="8px" />
          <div className="njp-trainers-count-row">
            <span className="njp-trainers-count">{loading ? '—' : formatNumber(atsWithin50Miles)}</span>
            <span className="njp-trainers-desc">
              verified athletic trainers within 50 miles of zip code {displayZip}
            </span>
          </div>
          <div className="njp-rate-row">
            <span className="njp-rate-text">
              Avg Transacted Rate In {displayState}: {loading ? '—' : formatRate(avgTransactedRate)}
            </span>
            <button className="njp-change-zip" onClick={this.openModal}>
              Change zip code
            </button>
          </div>
          <HorizontalRule dashed margin="10px" />
          <div className="njp-platform-stats">
            {platformStats.map(({ label, value }, i) => (
              <div key={i} className="njp-stat">
                <span className="njp-stat-value">{loading ? '—' : value}</span>
                <span className="njp-stat-label">{label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="njp-draft-card">
          <div className="njp-draft-text">
            <p className="njp-draft-heading">Create a Draft</p>
            <HorizontalRule dashed margin="8px" />
            <p className="njp-draft-desc">
              Want to take the Go4 platform for a test drive?
              <br />
              Create a draft of your job before posting.
            </p>
          </div>
          <Link className="njp-draft-btn" to="/create-event/1">
            CREATE A DRAFT
          </Link>
        </div>

        <div className="njp-bottom-row">
          <div className="njp-help-articles">
            <div className="njp-section-header">TOP HELP ARTICLES</div>
            <div className="njp-articles-list">
              {HELP_ARTICLES.map(({ label }, i) => (
                <p key={i} className="njp-article-link">
                  {label}
                </p>
              ))}
            </div>
          </div>

          <div className="njp-case-study">
            <p className="njp-case-study-type">[{jpType}] Case Study</p>
            <p className="njp-case-study-title">These words are the title of the case study.</p>
            <div className="njp-case-study-rule" />
            <span className="njp-read-more">Read More...</span>
          </div>
        </div>

        <MarketplaceStatsModal isOpen={modalOpen} onClose={this.closeModal} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.session.currentUser,
  marketplaceStats: state.dashboard.marketplaceStats,
});

export default connect(mapStateToProps)(NewJobPosterDashboard);
